import "@/common/i18n";

import { createRouter } from "@tanstack/react-router";

import { ClientProviders } from "@/components/ClientProviders";
import { DefaultErrorComponent } from "@/components/DefaultErrorComponent";
import { WondaNotFoundPage } from "@/screens/WondaNotFound";
import { api, trpcQueryUtils } from "@/trpc/react";
import { routeTree } from "./routeTree.gen";

export function getRouter() {
  const router = createRouter({
    routeTree,
    context: {
      api,
      trpcQueryUtils,
      // Injected at render time by ClientProviders via router.update()
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      auth: undefined!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      user: undefined!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      posthog: undefined!,
    },
    scrollRestoration: true,
    defaultPreload: "intent",
    defaultPreloadDelay: 0,
    defaultPendingMinMs: 500,
    defaultPendingMs: 1000,
    defaultPreloadStaleTime: 0,
    defaultNotFoundComponent: WondaNotFoundPage,
    defaultErrorComponent: DefaultErrorComponent,
    notFoundMode: "fuzzy",
    Wrap: ClientProviders,
  });

  return router;
}

declare module "@tanstack/react-router" {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
